import BoardDashboardContainer from './BoardDashboardContainer';
export default BoardDashboardContainer;
